import React from 'react';
import { makeStyles } from '@material-ui/core';
import appStyles from '../../../config/appStyles';
import Button from './common/Button';
import { useTranslation } from 'react-i18next';
import Image from './common/Image';
import { detectAlpha2Country } from '../../../utils/country';

const useStyles = makeStyles((theme) => appStyles.crossLoginButton(theme));

const CrossLoginButton = () => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'components']);

  const links = {
    FH: {
      uk: 'https://deagostini.com/uk/myarea',
      us: 'https://deagostini.com/us/myarea',
      de: 'https://deagostini.com/de/myarea',
    },
    PW: {
      uk: 'https://fanhome.com/uk/myarea',
      us: 'https://fanhome.com/us/myarea',
      de: 'https://fanhome.com/de/myarea',
    },
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.label}>{t('components:CrossLogin.label')}</div>
        <Button
          className={classes.button}
          component="a"
          href={`${links[process.env.REACT_APP_BRAND][detectAlpha2Country()]}`}
          target="_self"
          rel="noopener noreferrer">
          <span>{t('components:CrossLogin.cta')}</span>
          <Image className={classes.arrow} name="right_purple" />
        </Button>
      </div>
    </div>
  );
};

export default CrossLoginButton;
